(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Container", [], factory);
	else if(typeof exports === 'object')
		exports["Container"] = factory();
	else
		root["Container"] = factory();
})(this, function() {
return 